import _some from "./some";
import _makeIterator_ from "../function/makeIterator_";
var exports = {};
var some = _some;
var makeIterator = _makeIterator_;
/**
 * Returns first item that matches criteria
 */

function find(obj, callback, thisObj) {
  callback = makeIterator(callback, thisObj);
  var result;
  some(obj, function (value, key, obj) {
    if (callback(value, key, obj)) {
      result = value;
      return true; //break
    }
  });
  return result;
}

exports = find;
export default exports;